import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'platform/components';
import { Text, ThemeTextColorPath } from 'platform/foundation-tw';
import { useFormatCurrency } from 'platform/locale';
import { isNil } from 'ramda';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getStylesToRender } from '../../utils/getStylesToRender';
import { getTooltipProps } from '../../utils/getTooltipProps';
type MoneyValue = {
  amount: number;
  currency: string;
} | null;
type MoneyCellRendererProps = CellRendererProps<MoneyValue> & {
  getTooltipProps?: TooltipGetter;
};
type CellStyle = {
  textColor?: ThemeTextColorPath;
};
export function MoneyCellRenderer(props) {
  const $ = _c(23);
  let t0;
  if ($[0] !== props.column) {
    t0 = getCellClassName(props.column);
    $[0] = props.column;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const className = t0;
  const formatCurrency = useFormatCurrency();
  let t1;
  if ($[2] !== props) {
    t1 = getStylesToRender(props);
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const cellStyles = t1 as CellStyle | undefined;
  let t2;
  if ($[4] !== props.getTooltipProps || $[5] !== props.row) {
    t2 = getTooltipProps(props.row, {}, props.getTooltipProps);
    $[4] = props.getTooltipProps;
    $[5] = props.row;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const tooltipProps = t2;
  if (isNil(props.value)) {
    return null;
  }
  const decimalPlaces = typeof props.column.rendererParams?.decimalPlaces === "number" ? props.column.rendererParams.decimalPlaces : 2;
  let t3;
  if ($[7] !== decimalPlaces || $[8] !== formatCurrency || $[9] !== props.value.amount || $[10] !== props.value.currency) {
    t3 = formatCurrency(props.value.amount, props.value.currency, decimalPlaces);
    $[7] = decimalPlaces;
    $[8] = formatCurrency;
    $[9] = props.value.amount;
    $[10] = props.value.currency;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const cellValue = t3;
  const t4 = cellValue ?? undefined;
  const t5 = cellStyles?.textColor;
  const t6 = !props.column?.wrapText;
  let t7;
  if ($[12] !== cellValue || $[13] !== t5 || $[14] !== t6) {
    t7 = <Text color={t5} noWrap={t6} size="small">{cellValue}</Text>;
    $[12] = cellValue;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== className || $[17] !== t7) {
    t8 = <div className={className}>{t7}</div>;
    $[16] = className;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t4 || $[20] !== t8 || $[21] !== tooltipProps) {
    t9 = <Tooltip {...tooltipProps} label={t4}>{t8}</Tooltip>;
    $[19] = t4;
    $[20] = t8;
    $[21] = tooltipProps;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}